var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('iframe',{staticClass:"iframe_box",attrs:{"src":`/privacyService/${_vm.SRC}.html`,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }